/* eslint-disable */
try {
  window.ES6Promise.polyfill();
} catch(err) {
  console.log(err);
}
import ReactDOM from 'react-dom';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import { LocaleProvider } from 'antd';
import { Provider } from 'react-redux';
import 'assets/css/mod_css/app.less';
import _h5t from '../utils/h5t';
import createStore from '../store/createStore';
import reducer, { key, LOGIN_ASYNC } from './rootReducer';
import App from './app';

if (!sessionStorage.getItem('reloadBol')) { // 初次进入重载，解决页面缓存问题
  sessionStorage.setItem('reloadBol', true);
  window.location.reload();
}

_h5t.init();

export const store = createStore({}, { [key]: reducer });

store.dispatch({ type: LOGIN_ASYNC });

const MOUNT_NODE = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <LocaleProvider locale={zhCN}>
      <App />
    </LocaleProvider>
  </Provider>, MOUNT_NODE,
);



// WEBPACK FOOTER //
// ./src/views/entry.jsx